/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsForRegex": ["^draft"] }] */
import { useReducer, Reducer } from 'react';

import { produce } from 'immer';

import { PhoneOtpActionTypes, PhoneOtpActions, PhoneOtpState } from './usePhoneOtp.types';

// interface HookArgs {
//   onSuccessCallBack: () => void;
//   onErrorCallBack?: () => void;
//   formattedCountryCode: string;
//   country: string;
// }

const initialState: PhoneOtpState = {
  resendSuccess: false,
  otpValue: '',
  otpVerificationError: null,
  verificationLoading: false,
};

const reducer: Reducer<PhoneOtpState, PhoneOtpActions> = produce((draft, action) => {
  switch (action.type) {
    case PhoneOtpActionTypes.RESEND_SUCCESS:
      draft.resendSuccess = action.payload.value;
      draft.otpVerificationError = null;
      break;
    case PhoneOtpActionTypes.UPDATE_OTP_VALUE:
      draft.otpValue = action.payload.value;
      draft.otpVerificationError = null;
      break;
    case PhoneOtpActionTypes.VERIFICATION_ERROR:
      draft.otpVerificationError = action.payload.value;
      draft.resendSuccess = false;
      draft.verificationLoading = false;
      break;
    case PhoneOtpActionTypes.VERIFICATION_LOADING:
      draft.verificationLoading = action.payload.value;
      break;
    default:
      break;
  }
  return undefined;
});

const usePhoneOtp = () => {
  const [phoneOtpState, phoneOtpDispatch] = useReducer(reducer, initialState);

  return {
    ...phoneOtpState,
    phoneOtpDispatch,
  };
};

export default usePhoneOtp;
